var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartquestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8921 7.8972L34.8521 15.8172C35.3921 16.9197 36.8321 17.9772 38.0471 18.1797L45.2246 19.3722C49.8146 20.1372 50.8945 23.4672 47.587 26.7522L42.0071 32.3322C41.0621 33.2772 40.5445 35.0997 40.837 36.4047L42.4346 43.3122C43.6946 48.7797 40.7921 50.8947 35.9546 48.0372L29.2271 44.0547C28.0121 43.3347 26.0096 43.3347 24.7721 44.0547L18.0446 48.0372C13.2296 50.8947 10.3046 48.7572 11.5646 43.3122L13.1621 36.4047C13.4546 35.0997 12.9371 33.2772 11.9921 32.3322L6.41205 26.7522C3.12705 23.4672 4.18455 20.1372 8.77455 19.3722L15.9521 18.1797C17.1446 17.9772 18.5846 16.9197 19.1246 15.8172L23.0846 7.8972C25.2446 3.5997 28.7546 3.5997 30.8921 7.8972Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartquestionIcon);
export default __webpack_public_path__ + "static/media/startquestion_icon.5710ed0fdb9306688eaa76990f9caa1a.svg";
export { ForwardRef as ReactComponent };